(function (){
	'use strict';

	angular
		.module('as.groups')
		.controller('groupMembersController',groupMembersController);

	groupMembersController.$inject = ['$scope','$http','tag','$rootScope','$state','$stateParams','$filter'];
	function groupMembersController($scope,$http,tag,$rootScope,$state,$stateParams,$filter) {
		//variables
		var followersStream = 1;
		$scope.members = [];
		$scope.tag = tag;
		$scope.post_right={
			"sendMailEnabled":true,
			"include_demised": true,
			"right":false//,
			// "split_entity_categories":true,
			// "setEntityFields":1
		};
		$scope.startSearchNow={};
		$scope.searchInitialData = {
			fetchLost: 1,
			dataParams: {tags:[tag.id]},
			contextSearch:{tags:true},
			categories:[
				{
					fields: ["name"],
					displayName: $filter('asPortalLang')('Keyword',"Keyword")
				},
				{
					// fields: ["tags", "institute", "subinst", "yoj", "yop", "degree", "department", "specialization","entity_field"],
					fields: ["tags", "institute", "subinst", "yoj", "yop", "degree", "department", "specialization","entity_field"],
					displayName: $filter('asPortalLang')('Filters',"Filters")
				}
			]
		};

		$scope.is_group = $state.current.name.indexOf('inapp.group_')==0;
		
		//function bindings
		$scope.fetchFollowers = fetchFollowers;
		$scope.goBackToPrevPage = goBackToPrevPage;

		activate();

		function activate() {
			if(tag!=null){
                if($scope.tag.coordinators != undefined && typeof($scope.tag.coordinators)=='object') {
                    for (var i = 0; i < $scope.tag.coordinators.length; i++) {
                        if($scope.tag.coordinators[i].uid == $rootScope.app_data.uid) {
                            $scope.post_right.right=true;
                            break;
                        }
                    }
                }
                if($scope.tag && $scope.tag.extra && $scope.tag.extra.privacy==3 && !$scope.tag.following && !$rootScope.app_data.isAdmin){
                	if($scope.tag.is_group){
	                	swal({text:$filter('asPortalLang')('Group_Member_Restrict_Msg',"This page is visible only to the members of this group.")});
	                	$state.go('inapp.'+$stateParams.view+'_detail.main',{link:$scope.tag.link},{location: 'replace'});
	                	return;
                	}
                	if($scope.tag.is_chapter){
                		swal({text:$filter('asPortalLang')('Chapter_Member_Restrict_Msg',"This page is visible only to the members of this [TERM:Chapter:lowercase].")});
	                	$state.go('inapp.'+$stateParams.view+'_detail.main',{link:$scope.tag.link},{location: 'replace'});
	                	return;
                	}
                }
            }
			fetchFollowers();
			setTimeout(function() {
				$scope.startSearchNow.start();
			}, 100);
			$scope.reportingFun = {
				fetchingProfiles: function(report) {
				}
			};
		}

		function fetchFollowers() {
			if($scope.fetching || !$scope.tag || !$scope.tag.id)
				return;
			$scope.fetching = true;
			$http.post('./tags/followers',{tag_id:$scope.tag.id,stream:followersStream}).success(function(res) {
				console.log('tagfollowctrl', res);
				if(res.success == 1) {
					$scope.members = $scope.members.concat(res.data);
					followersStream++;
					fetchFollowers();
				}
				else if(res.success == 0) {
					$scope.noMoreMembers = true;
				}
				$scope.fetching = false;
			});
		}

		function goBackToPrevPage() {
			window.history.back();
		}
	}
})();